var React = require('react');

function Diploma360px (props) {
    return React.createElement("symbol",props,[React.createElement("defs",{"key":0}),React.createElement("path",{"d":"M59 39.945h-5a.999.999 0 1 1 0-1.997h4V1.988H2v35.96h26a.999.999 0 1 1 0 1.997H1c-.553 0-1-.447-1-.999V.989a.999.999 0 0 1 1-.998h58c.553 0 1 .447 1 .998v37.957a.999.999 0 0 1-1 .999zM41 18.969c4.963 0 9 4.033 9 8.99a8.94 8.94 0 0 1-2 5.638v13.341a.998.998 0 1 1-1.555.83l-5.444-3.626-5.446 3.626a.997.997 0 0 1-1.027.05.997.997 0 0 1-.528-.88V33.597a8.94 8.94 0 0 1-2-5.638c0-4.957 4.037-8.99 9-8.99zm0 1.998c-3.859 0-7 3.136-7 6.992 0 3.855 3.141 6.992 7 6.992s7-3.137 7-6.992c0-3.856-3.141-6.992-7-6.992zm-.554 21.144a1.004 1.004 0 0 1 1.11 0L46 45.071v-9.642a8.953 8.953 0 0 1-5 1.52 8.953 8.953 0 0 1-5-1.52v9.642l4.446-2.96zM27.001 17.927a1 1 0 1 1 0 1.998H15a1 1 0 1 1 0-1.998h12.001zM8 10.978a1 1 0 0 1 1-.999h42a1 1 0 1 1 0 1.998H9a1 1 0 0 1-1-.999z","key":1})]);
}

Diploma360px.displayName = "Diploma360px";

Diploma360px.defaultProps = {"preserveAspectRatio":"xMidYMid","viewBox":"0 0 60 47.94"};

module.exports = Diploma360px;

Diploma360px.default = Diploma360px;



//////////////////
// WEBPACK FOOTER
// ./data/assets/sprites/60px/diploma-3-60px.svg
// module id = 1188
// module chunks = 0